import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
    ButtonGroup,
    Button,
    InputControl,
    Container,
    ModalV2,
    ModalV2Title,
    ModalV2Content,
    ModalV2Footer,
    Row,
    Col,
} from '@si-armes/dsfr-react';
import BoutonFichierTelechargeable from 'components/Commun/Fichier/BoutonFichierTelechargeable';
import { useForm } from 'react-hook-form';
import { getAPI, postAPI } from 'store/apiReducer';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import SelectQuestionsCompteUsager from '../../../../components/form/referentiel/select/SelectQuestionsCompteUsager';
import usagerClientReducer from '../../../../store/usagerReducer';
import {
    API_CREER_COMPTE_USAGER_PARTIE_2_FINALISER,
    API_CREER_COMPTE_USAGER_PARTIE_2_GENERATION_PDF_LOGIN,
    API_CREER_COMPTE_USAGER_PARTIE_2_VALIDATION_TOKEN,
    CONTEXT_CREER_COMPTE_USAGER_PARTIE_2_FINALISER,
    CONTEXT_CREER_COMPTE_USAGER_PARTIE_2_GENERATION_PDF_LOGIN,
    CONTEXT_CREER_COMPTE_USAGER_PARTIE_2_VALIDATION_TOKEN,
} from '../../../../constants/apiUrls.constants';
import {
    INFOS_LOGIN_PDF,
    MIME_APPLICATION_OCTET_STREAM,
    MIME_APPLICATION_PDF,
} from '../../../../constants/fileConstant';
import formaterCreationCompteEtape2 from './components/FormaterCreationCompteEtape2';
import { isPswdIdentique, isPswdValid } from './components/MotDePasseCreationCompteEtape2';
import InputPassword from '../../../../components/Input/InputPassword';
import { getPath } from '../../../../utils/router';
import RoutesDeconnexion from '../../../deconnexion/routes';

const CreerCompteEtape2 = ({
    postApi,
    getApi,
    erreurValidationToken,
    uuidBrouillon,
    dataFinaliserCreationCompte,
    fichierPdfBase64,
    isLoadingFinaliserCreationCompte,
}) => {
    const { register, handleSubmit, watch, formState, trigger, getValues } = useForm({
        mode: 'onChange',
        criteriaMode: 'all',
    });

    const { token } = useParams();

    const [displayModaleTokenInvalide, setDisplayModaleTokenInvalide] = useState(false);
    const [displayBouttonPdfInfosLogin, setDisplayBouttonPdfInfosLogin] = useState(true);
    const [displayModaleLogin, setDisplayModaleLogin] = useState(false);
    const [isLoadingPdfInfosLogin, setIsLoadingPdfInfosLogin] = useState(false);
    const history = useHistory();

    const redirigerVersEcranConnexion = () => {
        window.location.href = process.env.REACT_APP_KEYCLOAK_LOGOUT_URI;
    };

    const ouvrirModaleTokenInvalide = () => {
        setDisplayModaleTokenInvalide(true);
    };

    const ouvrirModaleLogin = () => {
        setDisplayModaleLogin(true);
    };
    const fermerModaleLogin = () => {
        setDisplayModaleLogin(false);
        history.push(getPath(RoutesDeconnexion));
    };

    const getLogin = () => {
        if (dataFinaliserCreationCompte) {
            return dataFinaliserCreationCompte.login;
        }
        return 'Invalide';
    };

    const isStringNotEmpty = (stringToTest) => {
        return stringToTest !== '';
    };

    const isQuestionNotEmpty = () => {
        return (
            isStringNotEmpty(watch('question1')) &&
            isStringNotEmpty(watch('question2')) &&
            isStringNotEmpty(watch('question3'))
        );
    };

    const isReponseNotEmpty = () => {
        return (
            isStringNotEmpty(watch('reponse1')) &&
            isStringNotEmpty(watch('reponse2')) &&
            isStringNotEmpty(watch('reponse3'))
        );
    };

    const hasFormValid = () => {
        return (
            isReponseNotEmpty() &&
            isQuestionNotEmpty() &&
            isPswdValid(watch('motDePasse1')) &&
            isPswdIdentique(watch('motDePasse1'), watch('motDePasse2')) &&
            formState.isValid
        );
    };

    useEffect(() => {
        getApi(
            usagerClientReducer,
            API_CREER_COMPTE_USAGER_PARTIE_2_VALIDATION_TOKEN + token,
            CONTEXT_CREER_COMPTE_USAGER_PARTIE_2_VALIDATION_TOKEN,
        );
    }, []);

    useEffect(() => {
        if (dataFinaliserCreationCompte) {
            ouvrirModaleLogin();
        }
    }, [dataFinaliserCreationCompte]);

    useEffect(() => {
        if (erreurValidationToken) {
            ouvrirModaleTokenInvalide();
        }
    }, [erreurValidationToken]);

    /**
     * Relance la validité des questions si une question est modifiée.
     */
    useEffect(() => {
        if (!getValues('question1') && !getValues('question2') && !getValues('question3')) return;
        trigger(['question1', 'question2', 'question3']);
    }, [watch('question1'), watch('question2'), watch('question3')]);

    /**
     * @returns {string|null} Renvoie un message d'erreur si un doublon existe.
     */
    const verifierDoublonQuestion = (questionModifiee, autreQuestion1, autreQuestion2) => {
        const error =
            (questionModifiee === autreQuestion1 || questionModifiee === autreQuestion2) &&
            !!questionModifiee;
        if (error) {
            return 'La question est déjà sélectionnée, veuillez en choisir une autre.';
        }
        return null;
    };

    const getErreurMotDePasseInvalide = () => {
        if (watch('motDePasse1') && !isPswdValid(watch('motDePasse1'))) {
            return {
                message:
                    'Le mot de passe renseigné ne contient pas tous les éléments obligatoires. Veuillez en saisir un respectant le format indiqué.',
            };
        }
        return null;
    };

    const getErreurMotDePasseNonIdentique = () => {
        if (watch('motDePasse2') && !isPswdIdentique(watch('motDePasse1'), watch('motDePasse2'))) {
            return {
                message: "Veuillez renseigner le même mot de passe qu'au champ précédent.",
            };
        }
        return null;
    };

    const [isButtonLoading, setIsButtonLoading] = useState(false);

    const onSubmit = (dataForm) => {
        if (dataForm && hasFormValid() && uuidBrouillon) {
            setIsButtonLoading(true);
            const dataFormat = formaterCreationCompteEtape2(dataForm, uuidBrouillon);

            postApi(
                usagerClientReducer,
                API_CREER_COMPTE_USAGER_PARTIE_2_FINALISER,
                dataFormat,
                CONTEXT_CREER_COMPTE_USAGER_PARTIE_2_FINALISER,
            ).then(() => {
                setIsButtonLoading(false);
            });
        }
    };

    const genererPdfLogin = () => {
        if (uuidBrouillon) {
            setIsLoadingPdfInfosLogin(true);
            getApi(
                usagerClientReducer,
                API_CREER_COMPTE_USAGER_PARTIE_2_GENERATION_PDF_LOGIN + token,
                CONTEXT_CREER_COMPTE_USAGER_PARTIE_2_GENERATION_PDF_LOGIN,
            );
        }
    };

    useEffect(() => {
        if (fichierPdfBase64) {
            setIsLoadingPdfInfosLogin(false);
        }
    }, [fichierPdfBase64]);

    const hideBouttonPdfInfosLogin = () => {
        setDisplayBouttonPdfInfosLogin(false);
        history.push(getPath(RoutesDeconnexion));
    };

    const dialog = useRef();

    useEffect(() => {
        if (dialog.current) {
            dialog.current.showModal();
        }
    }, [dialog]);

    return (
        <Container>
            {displayModaleTokenInvalide ? (
                <ModalV2
                    id="tokenInvalide"
                    idModalTitle="tokenInvalide-title"
                    onClose={redirigerVersEcranConnexion}
                    size="sm"
                    ref={dialog}
                >
                    <ModalV2Content>
                        <ModalV2Title id="tokenInvalide-title">Token Invalide</ModalV2Title>
                        Token Invalide
                    </ModalV2Content>
                    <ModalV2Footer>
                        <div className="fr-grid-row">
                            <div className="fr-col-12 btn-group-align-right">
                                <Button
                                    name="Retour"
                                    variant="primary"
                                    onClick={redirigerVersEcranConnexion}
                                >
                                    Retour
                                </Button>
                            </div>
                        </div>
                    </ModalV2Footer>
                </ModalV2>
            ) : null}

            {displayModaleLogin ? (
                <ModalV2
                    id="infosLogin"
                    idModalTitle="infosLogin-title"
                    onClose={fermerModaleLogin}
                    size="sm"
                    ref={dialog}
                >
                    <ModalV2Content>
                        <ModalV2Title id="infosLogin-title">
                            Veuillez prendre connaissance de votre identifiant de connexion
                        </ModalV2Title>

                        <p>Votre Login est : {getLogin()}</p>
                        {displayBouttonPdfInfosLogin && (
                            <BoutonFichierTelechargeable
                                handleOnClick={genererPdfLogin}
                                label="PDF récapitulatif de vos infos"
                                isLoading={isLoadingPdfInfosLogin}
                                titreFichier={INFOS_LOGIN_PDF}
                                mimeType={MIME_APPLICATION_PDF || MIME_APPLICATION_OCTET_STREAM}
                                contenu={fichierPdfBase64}
                                handleHideBoutton={hideBouttonPdfInfosLogin}
                            />
                        )}
                    </ModalV2Content>
                </ModalV2>
            ) : null}

            <h1
                aria-label="Création de compte - Deuxième partie (2 sur 2)"
                className="text-center"
                data-testid="account-creation-step2-title"
            >
                Création de compte - Deuxième partie (2/2)
            </h1>

            <form onSubmit={handleSubmit(onSubmit)}>
                <Row className="margin-top-lg">
                    <Col col={12}>
                        <h3>
                            Veuillez renseigner les informations ci-dessous pour finaliser la
                            création de votre compte
                        </h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p>
                            Ces informations serviront à sécuriser votre compte et permettront de
                            confirmer votre identité
                        </p>
                    </Col>
                </Row>
                <Row gutters style={{ 'flex-direction': 'row-reverse' }}>
                    {/*
                    Le row reverse est là pour répondre à une contrainte d'accessibilité :
                    Les indications de mot de passe doivent être avant le champ afin que l'utilisateur connaisse
                    les contraintes.
                    Les indications ont donc été placé avant pour que les lecteur d'écrans commencent par ça, mais
                    pour conserver l'affichage, on a utilisé un row-reverse afin qu'elles s'affichent à droite.
                    */}
                    <Col col={12} lg={4}>
                        <p>Le mot de passe doit contenir :</p>
                        <ul>
                            <li>au moins 1 Majuscule</li>
                            <li>au moins 1 Minuscule</li>
                            <li>au moins 1 Chiffre</li>
                            <li>au moins 1 Caractère spécial (ex : + , - , ? , ! , % etc)</li>
                            <li>12 caractères minimum</li>
                        </ul>
                    </Col>
                    <Col col={12} lg={8}>
                        <InputPassword
                            name="motDePasse1"
                            label="Saisissez le mot de passe de votre compte :"
                            maxLength="300"
                            {...register('motDePasse1', {
                                required: true,
                            })}
                            error={getErreurMotDePasseInvalide()}
                        />
                        <InputPassword
                            name="motDePasse2"
                            label="Confirmez le mot de passe de votre compte :"
                            maxLength="300"
                            {...register('motDePasse2', {
                                required: true,
                            })}
                            error={getErreurMotDePasseNonIdentique()}
                        />
                    </Col>
                </Row>

                <Row className="margin-top-lg">
                    <Col col={12}>
                        <h3>
                            Veuillez sélectionner 3 questions et saisir les réponses associées. Ces
                            informations serviront en cas de problème d&apos;accès à votre compte.
                        </h3>
                    </Col>
                </Row>

                <Row gutters>
                    <Col col={12} lg={6}>
                        <SelectQuestionsCompteUsager
                            label="Question 1 : "
                            name="question1"
                            register={register('question1', {
                                required: true,
                                validate: (value) =>
                                    verifierDoublonQuestion(
                                        value,
                                        getValues('question2'),
                                        getValues('question3'),
                                    ),
                            })}
                            state={formState.errors?.question1 ? 'error' : null}
                            message={formState.errors?.question1?.message}
                        />
                    </Col>
                    <Col col={12} lg={6}>
                        <InputControl
                            id="reponse1"
                            name="reponse1"
                            label="Réponse 1 : "
                            maxLength="50"
                            uppercase
                            {...register('reponse1', {
                                required: true,
                            })}
                        />
                    </Col>
                </Row>
                <Row gutters>
                    <Col col={12} lg={6}>
                        <SelectQuestionsCompteUsager
                            label="Question 2 : "
                            name="question2"
                            register={register('question2', {
                                required: true,
                                validate: (value) =>
                                    verifierDoublonQuestion(
                                        value,
                                        getValues('question1'),
                                        getValues('question3'),
                                    ),
                            })}
                            state={formState.errors?.question2 ? 'error' : null}
                            message={formState.errors?.question2?.message}
                        />
                    </Col>
                    <Col col={12} lg={6}>
                        <InputControl
                            id="reponse2"
                            name="reponse2"
                            label="Réponse 2 : "
                            maxLength="50"
                            uppercase
                            {...register('reponse2', {
                                required: true,
                            })}
                        />
                    </Col>
                </Row>
                <Row gutters>
                    <Col col={12} lg={6}>
                        <SelectQuestionsCompteUsager
                            label="Question 3 : "
                            name="question3"
                            register={register('question3', {
                                required: true,
                                validate: (value) =>
                                    verifierDoublonQuestion(
                                        value,
                                        getValues('question2'),
                                        getValues('question1'),
                                    ),
                            })}
                            state={formState.errors?.question3 ? 'error' : null}
                            message={formState.errors?.question3?.message}
                        />
                    </Col>
                    <Col col={12} lg={6}>
                        <InputControl
                            id="reponse3"
                            name="reponse3"
                            label="Réponse 3 : "
                            maxLength="50"
                            uppercase
                            {...register('reponse3', {
                                required: true,
                            })}
                        />
                    </Col>
                </Row>

                <Row className="margin-top-lg">
                    <Col>
                        <ButtonGroup inline align="right">
                            <Button
                                name="etapePrecedente"
                                variant="secondary"
                                onClick={redirigerVersEcranConnexion}
                            >
                                Annuler
                            </Button>
                            <Button
                                name="valider"
                                variant="primary"
                                type="submit"
                                disabled={!hasFormValid() || isButtonLoading}
                                isLoading={isLoadingFinaliserCreationCompte}
                            >
                                Valider
                            </Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            </form>
        </Container>
    );
};

CreerCompteEtape2.propTypes = {
    postApi: PropTypes.func.isRequired,
    getApi: PropTypes.func.isRequired,
    // validationToken
    erreurValidationToken: PropTypes.bool,
    uuidBrouillon: PropTypes.string,
    // finalisationCreationCompte
    dataFinaliserCreationCompte: PropTypes.shape({
        login: PropTypes.string.isRequired,
    }).isRequired,
    fichierPdfBase64: PropTypes.string,
    isLoadingFinaliserCreationCompte: PropTypes.bool,
};

export default connect(
    (state) => {
        const { erreur: erreurValidationToken, data: uuidBrouillon } =
            state.compte.creer.validationToken;
        const { data: dataFinaliserCreationCompte, isLoading: isLoadingFinaliserCreationCompte } =
            state.compte.creer.finaliserCreationCompte;
        const { data: fichierPdfBase64 } = state.compte.creer.fichierPdfBase64;
        return {
            erreurValidationToken,
            uuidBrouillon,
            dataFinaliserCreationCompte,
            fichierPdfBase64,
            isLoadingFinaliserCreationCompte,
        };
    },
    {
        getApi: getAPI,
        postApi: postAPI,
    },
)(CreerCompteEtape2);
